// extracted by mini-css-extract-plugin
module.exports = {"title":"ReportBuilderForm_title_3zL8P","tooltip":"ReportBuilderForm_tooltip_2fdQo","panel":"ReportBuilderForm_panel_3SYjS"};